/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsGridSeller_user$ref: FragmentReference;
export type PdpRespSimilarItemsGridSeller_user = {|
  +serviceId: ?string,
  +$fragmentRefs: PdpRespSimilarItem_user$ref,
  +$refType: PdpRespSimilarItemsGridSeller_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGridSeller_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5b2e65f31db68091b30628f9f595bb50';
module.exports = node;
